import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  getEditingColumn,
  getEditingMeta,
} from './reducer';
import {
  requestEditColumn,
  requestEditCustomMeta,
} from './actions';
import ColumnForm from './column-form';
import MetaForm from '../custom-meta/form';

import styles from './styles.css';

class EditColumnModal extends Component {
  constructor() {
    super();
    this.state = {
      disabled: false,
      disabledMeta: false,
    };
    this.cancel = this.cancel.bind(this);
    this.cancelMetaModal = this.cancelMetaModal.bind(this);
    this.requestEditMetaData = this.requestEditMetaData.bind(this);

    this.handleCustomMetaSuccess = this.handleCustomMetaSuccess.bind(this);
    this.handleCustomMetaDeleteSuccess = this.handleCustomMetaDeleteSuccess.bind(this);
  }

  getShowingMetaForm() {
    const { meta } = this.props;
    return meta !== null;
  }

  cancel() {
    if (!this.state.disabled) {
      this.props.dispatch(requestEditColumn(null, null));
    }
  }

  cancelMetaModal() {
    if (!this.state.disabledMeta) {
      this.props.dispatch(requestEditCustomMeta(null));
    }
  }

  requestEditMetaData(meta) {
    this.props.dispatch(requestEditCustomMeta(meta));
  }

  handleCustomMetaSuccess() {
    this.cancelMetaModal();
  }

  handleCustomMetaDeleteSuccess() {
    this.cancelMetaModal();
  }

  renderColumnModal() {
    const {
      tableId, column,
      isRow,
      validObjects, validCustomMetaObjects,
    } = this.props;
    const showing = tableId !== null;
    const showingMetaForm = this.getShowingMetaForm();
    const label = isRow ? 'Row' : 'Column';

    let title = 'Manage';
    if (column && column._id !== undefined) {
      title = 'Edit';
    } else if (column && column._id === undefined) {
      title = 'Add';
    }
    return (
      <Modal
        key="column-modal"
        show={showing}
        onHide={this.cancel}
        className={showingMetaForm ? styles.fadedModal : ''}
      >
        <Modal.Header closeButton>{title} {label}</Modal.Header>
        {tableId !== null &&
          <div>
            <ColumnForm
              tableName={tableId}
              column={column}
              onSuccess={this.cancel}
              onCancel={this.cancel}
              validObjects={validObjects}
              isRow={isRow}
              validCustomMetaObjects={validCustomMetaObjects}
              requestEditCustomMeta={this.requestEditMetaData}
              requestAddCustomMeta={this.requestEditMetaData}
            />
          </div>
        }
        {tableId === null &&
          <Modal.Body>
            <div>&nbsp;</div>
          </Modal.Body>
        }
      </Modal>
    );
  }

  renderMetaFieldModal() {
    const {
      meta,
    } = this.props;
    const showing = meta !== null;
    let title = 'Manage Custom Field';
    if (meta && meta._id !== undefined) {
      title = 'Edit Custom Field';
    } else if (meta && meta._id === undefined) {
      title = 'Add Custom Field';
    }
    return (
      <Modal
        key="meta-modal"
        show={showing}
        onHide={this.cancelMetaModal}
      >
        <Modal.Header closeButton>{title}</Modal.Header>
        {meta !== null &&
          <Modal.Body>
            {meta._id === undefined &&
              <div className="well well-sm">
                This will allow you to add a custom field to your <code>{meta.object_type}</code> Object.
                All associated data of this field will be kept on TruVoice Automation.
              </div>
            }
            <MetaForm
              validObjects={this.props.validCustomMetaObjects}
              meta={meta}
              onCancel={this.cancelMetaModal}
              onSuccess={this.handleCustomMetaSuccess}
              onDeleteSuccess={this.handleCustomMetaDeleteSuccess}
            />
          </Modal.Body>
        }
        {meta === null &&
          <Modal.Body>
            <div>&nbsp;</div>
          </Modal.Body>
        }
      </Modal>
    );
  }

  render() {
    return [
      this.renderColumnModal(),
      this.renderMetaFieldModal(),
    ];
  }
}


EditColumnModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tableId: PropTypes.string,
  column: PropTypes.shape({}),
  meta: PropTypes.shape({}),
  isRow: PropTypes.bool,
  validObjects: PropTypes.arrayOf(PropTypes.string),
  validCustomMetaObjects: PropTypes.arrayOf(PropTypes.string),
};
EditColumnModal.defaultProps = {
  tableId: null,
  column: null,
  meta: null,
  isRow: false,
  validObjects: null,
  validCustomMetaObjects: null,
};
function mapStateToProps(state) {
  const editingColumn = getEditingColumn(state);
  return {
    tableId: editingColumn ? editingColumn.tableId : null,
    column: editingColumn ? editingColumn.column : null,
    meta: getEditingMeta(state),
  };
}
export default connect(mapStateToProps)(EditColumnModal);
